import { render, staticRenderFns } from "./WelfareGift.vue?vue&type=template&id=4aa17123&scoped=true&"
import script from "./WelfareGift.vue?vue&type=script&lang=js&"
export * from "./WelfareGift.vue?vue&type=script&lang=js&"
import style0 from "./WelfareGift.vue?vue&type=style&index=0&id=4aa17123&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa17123",
  null
  
)

export default component.exports